import { onAuthStateChanged, type User } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "./firebase.ts";
import { MOCK_MODE, mockUser } from "./mock.ts";

export function useAuth(): { user: User | null; ready: boolean } {
  const [state, setState] = useState<{ user: User | null; ready: boolean }>(
    () =>
      MOCK_MODE
        ? { user: mockUser, ready: true }
        : { user: null, ready: false },
  );
  useEffect(() => {
    if (MOCK_MODE) return;
    return onAuthStateChanged(auth, (u) => setState({ user: u, ready: true }));
  }, []);
  return state;
}
